<template>
  <div>
    <div class="bgform mainhotelform">
      <div class="row">
        <div class="col-lg-12 col-sm-12">
          <form action method="post" class="form-inner">
            <div class="row form-group" id="mainform">
              <div class="col-lg-6 col-sm-12">
                <base-input>
                  <input
                    type="radio"
                    @change="fullclearCities"
                    name="international"
                    value="no"
                    v-model="international"
                  />
                  India
                </base-input>
              </div>
              <div class="col-lg-6 col-sm-12">
                <base-input>
                  <input
                    type="radio"
                    @change="fullclearCities"
                    name="international"
                    value="yes"
                    v-model="international"
                  />
                  International
                </base-input>
              </div>
              <div class="col-lg-12 cyelol-sm-12">
                <h6>Select City or Location (Worldwide)</h6>

                <multiselect
                  :multiple="false"
                  placeholder="Select city"
                  v-model="cityvalue"
                  :options="cityoptions"
                  label="name"
                  open-direction="bottom"
                  :searchable="true"
                  :loading="isCitiesLoading"
                  track-by="id"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :options-limit="300"
                  :limit-text="limitText"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  group-values="groupdata"
                  group-label="grouptitle"
                  @search-change="getCities"
                ></multiselect>
              </div>
              <div class="col-lg-6 col-sm-12">
                <h6>Check-In Date</h6>
                <div
                  class="
                    input-daterange
                    datepicker
                    row
                    align-items-center
                    flatpickr
                  "
                >
                  <div class="col">
                    <!-- <base-input addon-left-icon="fa-lg calendar"> -->
                    <base-input addon-right-icon="fa fa-calendar">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        @input="checkdates"
                        :config="{ allowInput: true, minDate: 'today' }"
                        class="form-control datepicker"
                        v-model="datein"
                      ></flat-picker>
                    </base-input>
                    <!-- <i class="fa fa-calendar fa-lg calendar" aria-hidden="true"></i> -->
                  </div>
                </div>
                <h6 class="mt-2">{{ datein | formatDate }}</h6>
              </div>
              <div class="col-lg-6 col-sm-12">
                <h6>Check-Out Date</h6>

                <div class="input-daterange datepicker row align-items-center">
                  <div class="col">
                    <base-input addon-right-icon="fa fa-calendar">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{ allowInput: true, minDate: datein }"
                        class="form-control datepicker"
                        v-model="dateout"
                      ></flat-picker>
                    </base-input>
                  </div>
                </div>
                <h6 v-if="dateout != 'invalid date'" class="mt-2">
                  {{ dateout | formatDate }}
                </h6>
              </div>

              <div class="col-lg-12 col-sm-12">
                <h6>Guests & Rooms</h6>
                <input
                  v-model="roomstring"
                  class="form-control"
                  @click="showRoomPopup"
                  value
                  placeholder="Select Rooms & No of Guests"
                />
                <div v-show="showselectrooms" class="selectroom">
                  <div class="row">
                    <div class="col-lg-6 col-sm-12">
                      <h6>Rooms</h6>
                      <number-input
                        @change="checkroom"
                        v-model="trooms"
                        :min="1"
                        :max="6"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                      <h6>Adults</h6>
                      <number-input
                        @change="checkadults"
                        :disabled="fullguests"
                        v-model="guests"
                        :min="1"
                        :max="12"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                      <h6>Children Blow 6 Year</h6>
                      <number-input
                        :disabled="fullguests"
                        @change="totalguests"
                        v-model="guestsChildren"
                        :min="0"
                        :max="6"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                      <h6>Children 6-12 Year</h6>
                      <number-input
                        :disabled="fullguests"
                        @change="totalguests"
                        v-model="guestsChildrenabove"
                        :min="0"
                        :max="6"
                        inline
                        controls
                      ></number-input>
                    </div>
                    <div class="col-lg-12 col-sm-12 text-center">
                      <h6>&nbsp;</h6>
                      <button
                        @click="showRoomPopup"
                        type="button"
                        class="btn btn-warning"
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-lg-12 col-sm-12">
                <h6>TRAVELLING FOR</h6>
                
                <multiselect
                  :multiple="false"
                  placeholder="Select a Reason"
                  v-model="travfor"
                  :options="travforoptions"
                ></multiselect>
                
              </div> -->
              <div class="col-lg-12 col-sm-12 text-center">
                <button @click="submitsearch" type="button" class="primaryBtn">
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { APIURLS } from "../../api/constants";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { exit } from "process";

export default {
  name: "hotelForm",
  components: {
    flatPicker,
  },
  data() {
    
    return {
      international: "no",
      guests: 2,
      trooms: 1,
      guestsChildren: null,
      guestsChildrenabove: null,
      maxguests: 12,
      totalguest: 0,
      fullguests: false,
      travforoptions: ["Work", "Leisure"],
      travfor: null,
      isCitiesLoading: false,
      cityvalue: null,
      showselectrooms: false,
      roomstring: "",

      datein: new Date(),
      dateout: new Date(new Date().setDate(new Date().getDate() + 1)),
      cityoptions: [
        {
          id: "0",
          name: "Please type slowly and select cities",
        },
      ],
      dates: {
        simple: "2016-07-17",

        rangein: new Date(),
        rangeout: new Date().setDate(new Date().getDate() + 1),
      },
    };
  },
  methods: {
    totalguests() {
      this.maxguests = 12;
      this.totalguest =
        this.guests + this.guestsChildren + this.guestsChildrenabove;
      this.maxguests =
        this.maxguests -
        this.guests -
        this.guestsChildren -
        this.guestsChildrenabove;
      // console.log(this.maxguests);
      if (this.maxguests == 0) {
        this.fullguests = true;
      }
    },
    checkadults() {
      this.maxguests = 12;
      this.maxguests = this.maxguests - this.guests;
      if (this.guests == 12) {
        this.fullguests = true;
        this.guestsChildren = 0;
        this.guestsChildrenabove = 0;
      } else if (this.guests < 12) {
        this.fullguests = false;
      }
      this.totalguest = this.guests;
    },
    checkroom() {
      if (this.trooms >= 1) {
        if (this.guests < this.trooms * 2) {
          this.guests = this.trooms * 2;
        } else {
          this.guests = this.trooms * 2;
        }
      }
    },
    checkdates() {
      this.dateout = "";
      this.dateout = moment(String(this.datein))
        .add(1, "day")
        .format("YYYY-MM-DD");
      this.$forceUpdate();
    },

    showRoomPopup() {
      this.showselectrooms = !this.showselectrooms;
      this.roomstring =
        this.guests +
        this.guestsChildren +
        this.guestsChildrenabove +
        " Guests and " +
        this.trooms +
        " Room(s)";
    },
    limitText(count) {
      return `and ${count} other cities`;
    },
    getCities(query) {
      this.clearCities();
      this.isCitiesLoading = true;

      var urltogo =
        APIURLS.GET_CITIES +
        "?q=" +
        query +
        "&international=" +
        this.international;
      axios.get(urltogo).then((response) => {
        this.cityoptions = response.data;
        this.isCitiesLoading = false;
      });
      console.log(urltogo);
    },
    clearCities() {
      this.cityoptions = [];
    },
    fullclearCities() {
      this.cityvalue = null;
      this.getCities("");
    },
    submitsearch() {
      if (this.cityvalue == null || this.cityvalue == "") {
        this.$alertify.error("Please select city");
      } else {
        var cityString = this.cityvalue.id;
        var cityNameString = this.cityvalue.name;
        var datein1 = moment(String(this.datein)).format("YYYY-MM-DD");
        var dateout1 = moment(String(this.dateout)).format("YYYY-MM-DD");
        this.trooms
        localStorage.setItem("checkin", datein1);
        localStorage.setItem("checkout", dateout1);
        localStorage.setItem("guests", this.guests);
        localStorage.setItem("guestsChildren", this.guestsChildren);
        localStorage.setItem("guestsChildrenabove", this.guestsChildrenabove);
        localStorage.setItem("trooms", this.trooms);
        localStorage.setItem("totalguest", this.totalguest);
        localStorage.setItem("combohotel", "hotel");

        this.$router.push({
          path: "hotellist",
          query: {
            city: cityString,
            cityNames: cityNameString,
            checkindate: datein1,
            checkoutdate: dateout1,
            guests: this.guests,
            rooms: this.trooms,
            travfor: this.travfor,
            totalguest: this.totalguest,
          },
        });
      }
    },
  },
  created() {
    this.getCities("");
    this.roomstring =
      this.guests +
      this.guestsChildren +
      this.guestsChildrenabove +
      " Guests and " +
      this.trooms +
      " Room(s)";
  },
};
</script>

<style scoped>
.selectroom {
  max-width: 99%;
  /* border: 1px solid black; */
  padding: 0.5em;
  -webkit-box-shadow: 3px 9px 49px -30px rgba(0, 0, 0, 0.83);
  -moz-box-shadow: 3px 9px 49px -30px rgba(0, 0, 0, 0.83);
  box-shadow: 3px 9px 49px -30px rgba(0, 0, 0, 0.83);
}
.bgcolor {
  width: 100%;
  background: #f2f2f2;
  background-repeat: no-repeat;
  background-image: linear-gradient(to bottom, #051322, #15457c);
  padding: 50px;
  margin: 5% 5% 0 5%;
  border-radius: 15px;
}
.input-group-text {
  color: #0a6ad6 !important;
}
#mainform {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.bgform {
  background: #fff;
  border-right: 1px solid #e4e4e4;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);
  margin: 13.8% 5% 0;
}

.form-inner {
  padding: 0 0.9rem;
  border-radius: 0.25rem;
  margin: 1rem 1rem;
}
.form-inner h6 {
  font-size: 0.8rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 800;
}
.form-inner .col-md-4,
.col-md-2 {
  border: solid 1px #c7c6c6;
  border-right: solid 1px #c7c6c6;
  padding-bottom: 0.8rem;
}

.col-md-4:hover,
.col-md-2:hover {
  background-color: #008cff40;
}

.fa-angle-down {
  color: #008cff;
  margin-left: 0.1rem;
}

.form-group {
  margin-bottom: 0%;
}

input[type="text"] {
  /* background: transparent !important;
  border: none !important;
  outline: none !important;
  padding: 0px !important;  */
  color: #000;
  font-weight: 900;
}

.form-control:focus {
  box-shadow: 0 0 0 0rem rgba(0, 0, 0, 0);
}
.calendar {
  position: absolute;
  right: 1.5rem;
  top: 1rem;
}
.angle-down {
  position: absolute;
  right: 1.5rem;
  top: 4rem;
}

.primaryBtn {
  -webkit-border-radius: 34px;
  -moz-border-radius: 34px;
  border-radius: 34px;
  background-image: -webkit-linear-gradient(354deg, #172b4d, #5082c2);
  background-image: -moz-linear-gradient(354deg, #172b4d, #5082c2);
  background-image: -o-linear-gradient(354deg, #172b4d, #5082c2);
  background-image: linear-gradient(96deg, #172b4d, #5082c2);
  -webkit-box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
  display: inline-block;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  color: #fff;
  text-transform: uppercase;
  cursor: pointer;
  outline: 0;
  border: 0;
  text-align: center;
  padding: 0.8rem 2rem;
  margin-top: 1rem;
}
.primaryBtn:hover {
  box-shadow: 0 0 11px rgb(82 80 80 / 54%);
  color: #172b4d;
  background-color: #f7dc69;
  background-image: unset;
  border: 1px solid #f7dc69;
}

::-webkit-input-placeholder {
  /* Chrome */
  color: #000;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: #000;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #000;
  opacity: 1;
}
:-moz-placeholder {
  /* Firefox 4 - 18 */
  color: #000;
  opacity: 1;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.multiselect__option--disabled {
  background: #083578 !important;
  color: #f7dc69 !important;
}
.multiselect__option {
  white-space: unset;
}
@media (max-width: 768px) {
  .bgform {
    width: 90%;
    margin-top: 20%;
  }
  .datepicker > .col {
    margin-left: 0.25rem;
  }
  .input-group .form-control:not(:first-child) {
    border-left: 0.2rem solid #ccc !important;
    padding-left: 9px !important;
  }
}
.mainhotelform {
  border-radius: 1em;
}
</style>
<style>
.multiselect__option--disabled {
  background: #083578 !important;
  color: #ffffff !important;
}
</style>